export default "__VITE_ASSET__N_1gqRp8__"